// Copyright (c) 2016 Deere & Company

import React, {Component, PropTypes} from 'react';
import {buildClaimRoutes} from '../../../shared/services/build-claim-route';
import {formatClaimNumber} from '../../../shared/services/format-claim-number';

/* eslint-disable react/prefer-stateless-function */

class ClaimNumberCellRenderer extends Component {

    render() {

        return (
            <div className='claim-cell-renderer'>
                <a
                    className='claim-link'
                    href={`#${buildClaimRoutes(encodeURI(this.props.data.claimType), encodeURI(this.props.data.subClaimType), encodeURI(this.props.value))}`}
                    rel='noopener noreferrer'
                    target='_blank'
                >
                    {formatClaimNumber(this.props.value)}
                </a>
            </div>
        );

    }

}

ClaimNumberCellRenderer.displayName = 'ClaimNumberCellRenderer';
ClaimNumberCellRenderer.propTypes = {
    data: PropTypes.object.isRequired,
    value: PropTypes.string.isRequired
};

export default ClaimNumberCellRenderer;



// WEBPACK FOOTER //
// ./src/reports/shared/report-cell-renderers/claim-number-cell-renderer.js